import { makeStyles } from '@material-ui/core/styles'
import Loader from './Loader.gif'

const useStyles = makeStyles((theme) => ({
  progressSection: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: 10001,
  },
  progressOverlay: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 10002,
    backgroundColor: 'grey',
    opacity: '0.25',
  },
  progressText: {
    fontSize: 25,
    fontWeight: 500,
  },
  alignScreenCenter: {
    display: 'flex',
    alignItems: 'center',
    height: '100vh',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}))

const LoadingComponent = (props: any) => {
  const { showLoader, showLoadingText, loadingText } = props
  const classes = useStyles()

  const progressBar = showLoader ? (
    <div className={classes.progressSection}>
      <div className={classes.progressOverlay}></div>
      <div className={classes.alignScreenCenter}>
        <img src={Loader} alt="spinner" />
        {showLoadingText && (
          <p className={classes.progressText}>
            {loadingText ?? `Loading in progress, this may take a few minutes`}
          </p>
        )}
      </div>
    </div>
  ) : null

  return progressBar
}

export default LoadingComponent
